import React from "react";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";

export default function DialogTermsFinance({ showDetailsModal, setShowDetailsModal, persona }) {
    const fd = persona?.infoBudget?.financial_details;
    const gc = fd?.groupConcepts;
    const iva = fd?.iva_percentage ? parseFloat(fd.iva_percentage) / 100 : 0.16;
    const isFinance = fd?.typeBudget === 'finance';

    // Finance: rentaTotal viene CON IVA → dividir para obtener sin IVA
    // Pure: rentaTotal viene SIN IVA → multiplicar para obtener con IVA
    // Conceptos individuales ya vienen sin IVA en ambos tipos
    const rentaTotal = gc?.rentaTotal || 0;
    const totalSinIva = isFinance ? rentaTotal / (1 + iva) : rentaTotal;
    const totalConIva = isFinance ? rentaTotal : rentaTotal * (1 + iva);
    const ivaMonto = totalConIva - totalSinIva;

    const fmt = (val) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);

    return (
        <Dialog
                header="Desglose Completo de Cotización"
                visible={showDetailsModal}
                style={{ width: '90vw', maxWidth: '1000px' }}
                onHide={() => setShowDetailsModal(false)}
                maximizable
                modal
            >
                {persona?.infoBudget?.financial_details && (
                    <div className="grid">
                        {/* Información del Vehículo y Plazo */}
                        <div className="col-12 mb-4">
                            <div className="p-4 border-round-lg border-1 border-blue-200 ">
                                <h5 className="text-lg font-semibold text-blue-800 mb-3">
                                    <i className="pi pi-car mr-2"></i>
                                    Información del Vehículo y Plazo
                                </h5>
                                <div className="grid">
                                    <div className="col-12 md:col-6">
                                        <div className="mb-2">
                                            <strong>Vehículo:</strong> {persona?.infoBudget?.vehicle?.brand} {persona?.infoBudget?.vehicle?.model} {persona?.infoBudget?.vehicle?.year}
                                        </div>
                                        <div className="mb-2">
                                            <strong>Descripción:</strong> {persona?.infoBudget?.vehicle?.description}
                                        </div>
                                        <div className="mb-2">
                                            <strong>Tipo:</strong> {persona?.infoBudget?.vehicule_type}
                                        </div>
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <div className="mb-2">
                                            <strong>Plazo:</strong> {persona?.infoBudget?.term} meses
                                        </div>
                                        <div className="mb-2">
                                            <strong>Motor:</strong> {persona?.infoBudget?.engine}
                                        </div>
                                        <div className="mb-2">
                                            <strong>Precio:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona?.infoBudget?.price || 0)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Desglose de Enganche */}
                        {persona.infoBudget.financial_details.groupConceptsEnganche && (
                            <div className="col-12 md:col-6">
                                <div className="p-4 border-round-lg border-1 border-orange-200  h-full">
                                    <h5 className="text-lg font-semibold text-orange-800 mb-3">
                                        <i className="pi pi-money-bill mr-2"></i>
                                        Desglose de Enganche
                                    </h5>
                                    <div className="text-gray-600">
                                        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>Enganche:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.enganche || 0)}
                                        </div>
                                        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}  >
                                            <strong>Comisión Apertura:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.comisionApertura || 0)}
                                        </div>
                                        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>Renta Anticipada:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.rentaAnticipada || 0)}
                                        </div>
                                        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>Gastos Originación:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.gastosOriginacion || 0)}
                                        </div>
                                       
                                        <div className="mb-2 border-top-1 border-orange-300 pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>Subtotal (sin IVA):</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.subWithoutIva || 0)}
                                        </div>
                                        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>IVA:</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.subWitIva || 0)}
                                        </div>
                                        <div className="mb-2 border-top-1 border-orange-300 pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>Total (incl IVA):</strong> {new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.financial_details.groupConceptsEnganche.totalWitIva || 0)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Desglose Completo de Conceptos */}
                        {gc && (
                            <div className="col-12 md:col-6">
                                <div className="p-4 border-round-lg border-1 border-purple-200 h-full">
                                    <h5 className="text-lg font-semibold text-purple-800 mb-3">
                                        <i className="pi pi-calculator mr-2"></i>
                                        Desglose Completo de Conceptos
                                    </h5>
                                    <div className="text-gray-600">
                                        {isFinance ? (
                                            <>
                                                {/* Finance: renta, seguro, gps, adminGestorias ya vienen sin IVA del backend */}
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Pago Mensual Base (s/IVA):</strong> {fmt(gc.renta)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Seguro (s/IVA):</strong> {fmt(gc.seguro)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>GPS (s/IVA):</strong> {fmt(gc.gps)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Gestorías (s/IVA):</strong> {fmt(gc.adminGestorias)}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {/* Pure: los conceptos individuales ya vienen sin IVA */}
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Renta:</strong> {fmt(gc.renta)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Gastos Administrativos:</strong> {fmt(gc.administraciónFlota)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Seguro Automotriz:</strong> {fmt(gc.seguro)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Administración Seguro Automotriz:</strong> {fmt(gc.admonSeguro)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Servicio Geolocalización:</strong> {fmt(gc.adminGPS)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Servicio Trámite Vehicular:</strong> {fmt(gc.adminGestorias)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Servicios de Entrega y Revisión:</strong> {fmt(gc.servicioEntregaSeguimiento)}
                                                </div>
                                                <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <strong>Otros Servicios:</strong> {fmt(gc.noDeducibleOtrosServicios)}
                                                </div>
                                            </>
                                        )}
                                        <div className="mb-2 border-top-1 border-purple-300 pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>Total Pago Mensual (sin IVA):</strong> {fmt(totalSinIva)}
                                        </div>
                                        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>IVA:</strong> {fmt(ivaMonto)}
                                        </div>
                                        <div className="mb-2 border-top-1 border-purple-300 pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <strong>Total Pago Mensual (incl IVA):</strong> {fmt(totalConIva)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Dialog>
    )
}